
import { computed, defineComponent, onMounted, ref } from "vue";
import moment from "moment";
import {
  listKenaikanPangkatMohon,
  listKenaikanPangkatMohon2,
  viewNaikPangkatMohon,
} from "@/apollo/dashboard/kenaikanPangkat";
import { useApolloClient, useMutation, useQuery } from "@vue/apollo-composable";
import { ElementAnimateUtil } from "@/assets/ts/_utils";
import { useRouter } from "vue-router";
import { EncryptCredential } from "@/assets/ts/_utils/ReportEncryptCredential";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { perkhidmatanBatal, perkhidmatanDrafTamatTempoh } from "@/apollo/perkhidmatan/naikpangkat";

export default defineComponent({
  name: "dashboard-status-kenaikan-pangkat",
  methods:{
    isShowBtnKemaskini: function(naikPangkatMohon)
    {
      return ['DRAF', 'PERMOHONAN_MANUAL', 'PERMOHONAN_OFFLINE'].indexOf(naikPangkatMohon.status_permohonan) >= 0;
    },
    isShowDisabledBtnKemaskini: function(naikPangkatMohon)
    {
      return naikPangkatMohon.status_permohonan == 'DRAF_TAMAT_TEMPOH'
    },
    isShowBtnCetak: function(naikPangkatMohon)
    {
      // return this.isShowBtnKemaskini(naikPangkatMohon) == false;
        return (
            !this.isShowBtnKemaskini(naikPangkatMohon) &&
            !this.isShowDisabledBtnKemaskini(naikPangkatMohon)
        );
    },
    isShowBtnBatalMohon: function(borangNaikPangkatMohon)
    {
      return (this.isShowBtnKemaskini(borangNaikPangkatMohon) ||
              this.isShowDisabledBtnKemaskini(borangNaikPangkatMohon) ||
                borangNaikPangkatMohon.status_permohonan == 'HANTAR') &&
              (borangNaikPangkatMohon.naik_pangkat?.status == 'BUKA' ||
                borangNaikPangkatMohon.naik_pangkat?.status == 'BARU') &&
              !borangNaikPangkatMohon.status_keputusan;
    }
  },
  setup() {
    const { resolveClient } = useApolloClient();
    const butirPerkhidmatan = ref({});
    const isLoading = ref(false);
    const search = ref("");
    const mohon_id = ref(0);
    const router = useRouter();
    const selectedTab = ref(0);
    const searchVar = computed(() => {
      return { tajuk: search.value ? `%${search.value}%` : "" };
    });

    const { result, refetch: listPerkhidmatanMohonRefetch } = useQuery(
      listKenaikanPangkatMohon2,
      searchVar,
      {
        fetchPolicy: "no-cache",
      }
    );

    const kenaikanPangkatMohonList = computed(() => {
      // const list = result.value?.naikPangkatMohonList ?? [];
      const list = result.value?.myListMohonNaikPangkat ?? [];

      if (list.length > 0) {
        getDetails(list[0].id);
      }

      console.log("List", list);

      return list;
    });

    const formatDate = (date: string) => {
      return date ? moment(date).format("DD MMM YYYY") : "-";
    };

    const getDetails = async (id) => {
      const client = resolveClient();
      isLoading.value = true;

      const { data, loading } = await client.query({
        query: viewNaikPangkatMohon,
        variables: {
          input: parseInt(id),
        },
        fetchPolicy: "network-only",
      });

      isLoading.value = loading;
      butirPerkhidmatan.value = { ...data.naikPangkatMohonView };
      ElementAnimateUtil.scrollTop(0, 200);
    };

    const borangTypeLabel = (value) => {
      switch (value) {
        case "KNP":
          return "KENAIKAN PANGKAT";
        case "PMK":
          return "PEMANGKUAN";
        default:
          return "";
      }
    };

    const borangJenisLabel = (value) => {
      switch (value) {
        case "IKHTISAS":
          return "PERMOHONAN PEMANGKUAN AKAUNTAN MELALUI KELULUSAN BADAN IKHTISAS";
        case "PMK_WA52_WA54":
          return "PERMOHONAN PEMANGKUAN AKAUNTAN WA52 KE WA54 MELALUI SIJIL BADAN IKHTISAS";
        case "PMK_WA48_WA52":
          return "PERMOHONAN PEMANGKUAN AKAUNTAN WA48 KE WA52 MELALUI SIJIL BADAN IKHTISAS";
        case "PMK_WA44_WA48":
          return "PERMOHONAN PEMANGKUAN AKAUNTAN WA44 KE WA48 MELALUI SIJIL BADAN IKHTISAS";
        case "PMK_WA41_WA44":
          return "PERMOHONAN PEMANGKUAN AKAUNTAN WA41 KE WA44 MELALUI SIJIL BADAN IKHTISAS";

        case "KNP_WA52_WA54":
          return "PERMOHONAN KENAIKAN PANGKAT AKAUNTAN WA52 KE WA54";
        case "KNP_WA48_WA52":
          return "PERMOHONAN KENAIKAN PANGKAT AKAUNTAN WA48 KE WA52";
        case "KNP_WA44_WA48":
          return "PERMOHONAN KENAIKAN PANGKAT AKAUNTAN WA44 KE WA48";
        case "KNP_WA41_WA44":
          return "PERMOHONAN KENAIKAN PANGKAT AKAUNTAN WA41 KE WA44";


        case "W36_W40":
          return "PERMOHONAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN W36 KE W40";
        case "W32_W36":
          return "PERMOHONAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN W32 KE W36";
        case "W29_W32":
          return "PERMOHONAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN W29 KE W32";
        case "W26_W28":
          return "PERMOHONAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN W26 KE W28";
        case "W22_W26":
          return "PERMOHONAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN W22 KE W26";
        case "W19_W22":
          return "PERMOHONAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN W19 KE W22";
        case "PRO":
          return "PERMOHONAN KENAIKAN PANGKAT AKAUNTAN";
        case "PELAKSANA":
          return "PERMOHONAN KENAIKAN PANGKAT KUMPULAN PELAKSANA";

        case "KNP_W19_W22":
          return "PERMOHONAN KENAIKAN PANGKAT JAWATAN PEMBANTU AKAUNTAN W19 KE W22";
        case "KNP_W22_W26":
          return "PERMOHONAN KENAIKAN PANGKAT JAWATAN PEMBANTU AKAUNTAN W22 KE W26";
        case "KNP_W26_W28":
          return "PERMOHONAN KENAIKAN PANGKAT JAWATAN PEMBANTU AKAUNTAN W26 KE W28";
        case "KNP_W32_W36":
          return "PERMOHONAN KENAIKAN PANGKAT JAWATAN PENOLONG AKAUNTAN W32 KE W36";
        case "KNP_W29_W32":
          return "PERMOHONAN KENAIKAN PANGKAT JAWATAN PENOLONG AKAUNTAN W29 KE W32";
        case "KNP_W36_W40":
          return "PERMOHONAN KANAIKAN PANGKAT JAWATAN PENOLONG AKAUNTAN W36 KE W40";

        case "TBK":
          return "PERMOHONAN KENAIKAN PANGKAT SECARA TIME-BASED BERASAS KECEMERLANGAN (TBK1 & TBK2)";
        case "TBK1_H11_H14_PEMANDU":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED H11 KE H14 (PEMANDU KENDERAAN)";
        case "TBK1_H11_H14_PA":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED H11 KE H14 (PEMBANTU AWAM)";
        case "TBK1_N11_N14":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N11 KE N14 (PEMBANTU OPERASI)";
        case "TBK1_N19_N22_PKP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEGAWAI KHIDMAT PELANGGAN";
        case "TBK1_N19_N22_PA":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PENYELIA ASRAMA";
        case "TBK1_W19_W22_PTKW":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED W19 KE W22 PEMBANTU TADBIR (KEWANGAN)";
        case "TBK1_N19_N22_PSP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEMBANTU / SETIAUSAHA PEJABAT";
        case "TBK1_N19_N22_PTPO":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEMBANTU TADBIR (PERKERANIAN / OPERASI)";
        case "TBK1_N29_N32_PSP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N29 Ke N32 PEMBANTU / SETIAUSAHA PEJABAT";
        case "TBK1_N29_N32_PPT":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N29 Ke N32 PENOLONG PEGAWAI TADBIR";

        case "TBK2_H14_H16_PEMANDU":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED H14 KE H16 (PEMANDU KENDERAAN)";
        case "TBK2_H14_H16_PA":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED H14 KE H16 (PEMBANTU AWAM)";
        case "TBK2_N14_N16":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N14 KE N16 (PEMBANTU OPERASI)";
        case "TBK2_N22_N26_PTPO":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEMBANTU TADBIR (PERKERANIAN /OPERASI)";
        case "TBK2_N22_N26_PKP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEGAWAI KHIDMAT PELANGGAN";
        case "TBK2_N22_N26_PA":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PENYELIA ASRAMA";
        case "TBK2_W22_W26_PTKW":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED W22 Ke W26 PEMBANTU TADBIR (KEWANGAN)";
        case "TBK2_N22_N26_PSP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEMBANTU / SETIAUSAHA PEJABAT";
        case "TBK2_N32_N36_PPT":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N32 Ke N36 PENOLONG PEGAWAI TADBIR";
        case "TBK2_N32_N36_PSP":
          return "PERMOHONAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N32 Ke N36 PEMBANTU / SETIAUSAHA PEJABAT";

        case "TBK1_W19_W22":
          return "PERMOHONAN KENAIKAN PANGKAT SECARA TIME-BASED BERASAS KECEMERLANGAN (TBK1) BAGI GRED W19 KE W22";
        case "TBK2_W22_W26":
          return "PERMOHONAN KENAIKAN PANGKAT SECARA TIME-BASED BERASAS KECEMERLANGAN (TBK2) BAGI GRED W22 KE W26";
        case "TBK1_W29_W32":
          return "PERMOHONAN KENAIKAN PANGKAT SECARA TIME-BASED BERASAS KECEMERLANGAN (TBK1) BAGI GRED W29 KE W32";
        case "TBK2_W32_W36":
          return "PERMOHONAN KENAIKAN PANGKAT SECARA TIME-BASED BERASAS KECEMERLANGAN (TBK2) BAGI GRED W32 KE W36";
        default:
          return "-";
      }
    };

    const mohonStatusLabel = (status_permohonan, status_keputusan) => {
      switch ((status_permohonan ?? "") + "|" + (status_keputusan ?? "")) {
        case "DRAF|":
          return "DRAF";
        case "DRAF_TAMAT_TEMPOH|":
          return "TAMAT TEMPOH IKLAN";
        case "HANTAR|":
          return "MENUNGGU PERAKUAN KETUA JABATAN";
        case "PERAKUAN_KETUA|":
          return "MENUNGGU PENGESAHAN PSM";
        case "DRAF_PSM|":
          return "MENUNGGU PENGESAHAN PSM";
        case "PENGESAHAN_PSM|":
          return "DALAM PROSES";
        case "SEMAKAN|":
          return "DALAM SEMAKAN";
        case "KUIRI|":
          return "MENUNGGU PENGESAHAN KUIRI";
        case "LENGKAP|":
          return "LENGKAP";
        case "PERTIMBANGAN|":
          return "MENUNGGU KEPUTUSAN";
        case "PERTIMBANGAN|BERJAYA":
          return "KEPUTUSAN BERJAYA";
        case "PERTIMBANGAN|TIDAK_BERJAYA":
          return "KEPUTUSAN TIDAK BERJAYA";
        case "PERTIMBANGAN|CALON_SIMPANAN":
          return "CALON SIMPANAN";
        case "BATAL|":
          return "DIBATALKAN";
        case "PERMOHONAN_MANUAL|":
          return "PERMOHONAN MANUAL";
        case "PERMOHONAN_OFFLINE|":
          return "PERMOHONAN OFFLINE";
        default:
          return "-";
      }
    };

    const sambungDraf = (item, mohon) => {
      const now = moment();
      const deadline = item?.tarikh_permohonan_tamat
        ? moment(item.tarikh_permohonan_tamat).endOf("day")
        : null;
      const isExpired = deadline ? now.isAfter(deadline) : false;
      const isOffline = mohon?.status_permohonan === "PERMOHONAN_OFFLINE";

      if (isExpired && !isOffline) {
        Swal.fire({
          html: "<b>Tempoh permohonan iklan telah tamat.</b><br>Permohonan tidak boleh dikemaskini atau dihantar selepas tarikh tutup.",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          PerkhidmatanDrafTamatTempoh({
            input: {
              id: Number(mohon.id),
              status_permohonan: "DRAF_TAMAT_TEMPOH",
            }
          }).then(() => {
            listPerkhidmatanMohonRefetch();
          }).catch(error => {
            console.error("Mutation error:", error);
          });
          PerkhidmatanDrafTamatTempohDone(() => {
            listPerkhidmatanMohonRefetch();
          });
        })
        ;
        return;
      }
      router.push({ name: "borang-urusan-draf", params: { id: item.id } });
    };

    const { mutate: PerkhidmatanDrafTamatTempoh, onDone: PerkhidmatanDrafTamatTempohDone } = useMutation(perkhidmatanDrafTamatTempoh);

    const { mutate: PerkhidmatanBatal, onDone: PerkhidmatanBatalDone } =
      useMutation(perkhidmatanBatal, () => ({
        variables: {
          input: {
            id: Number(mohon_id.value),
            status_permohonan: "BATAL",
          },
        },
      }));

    const batalPermohonan = (id) => {
      console.log("id", id);
      Swal.fire({
        title: "Adakah anda pasti untuk membatalkan permohonan ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Pasti",
        cancelButtonText: "Tidak",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (!result.isConfirmed) return;
        PerkhidmatanBatal();
        PerkhidmatanBatalDone(() => {
          Swal.fire({
            text: "Permohonan anda telah dibatalkan.",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          }).then(() => {
            listPerkhidmatanMohonRefetch();
          });
        });
      });
    };

    const muatTurunSuratSiaran = (lampiran) => {
      window.open(lampiran?.url, "_blank");
    };

    const getLampiran = (id) => {
      const pp = EncryptCredential("user");
      let url = "";

      const baseURL =
        process.env["VUE_APP_REPORT_URL"] ||
        "http://175.139.185.141:8080/jasperserver/";

      url = `${baseURL}rest_v2/reports/JANM_Reports/Others/Maklumat_Permohonan_Naik_Pangkat_dan_Pemangkuan___Pemohon.pdf?pp=${pp}&id=${id}`;

      window.open(url, "_blank");
    };

    const getSuratSiaran = (id, jenis) => {
      const pp = EncryptCredential("user");
      let url = "";

      const baseURL =
        process.env["VUE_APP_REPORT_URL"] ||
        "http://175.139.185.141:8080/jasperserver/";

      if (jenis == "PRO")
        url = `${baseURL}rest_v2/reports/JANM_Reports/Surat_Siaran_Perkhidmatan/Surat_Siaran_Akauntan_Kenaikan_Pangkat_v2.pdf?pp=${pp}&id=${id}`;
      else if (jenis.includes("TBK1") || jenis.includes("TBK2")) {
        if (jenis == "TBK1_W19_W22" || jenis == "TBK2_W22_W26")
          url = `${baseURL}rest_v2/reports/JANM_Reports/Surat_Siaran_Perkhidmatan/Surat_Siaran_TBK1_dan_TBK2_Pembantu_Akauntan.pdf?pp=${pp}&id=${id}`;
        else if (jenis == "TBK1_W29_W32" || jenis == "TBK2_W32_W36")
          url = `${baseURL}rest_v2/reports/JANM_Reports/Surat_Siaran_Perkhidmatan/Surat_Siaran_TBK1_dan_TBK2_Penolong_Akauntan.pdf?pp=${pp}&id=${id}`;
        else {
          url = `${baseURL}rest_v2/reports/JANM_Reports/Surat_Siaran_Perkhidmatan/Surat_Siaran_TBK1_dan_TBK2_Skim_Lain.pdf?pp=${pp}&id=${id}`;
        }
      } else
        url = `${baseURL}rest_v2/reports/JANM_Reports/Surat_Siaran_Perkhidmatan/Surat_Siaran_Pembantu_dan_Penolong_Akauntan_Kenaikan_Pangkat_v2.pdf?pp=${pp}&id=${id}`;

      window.open(url, "_blank");
    };

    onMounted(() => {
      listPerkhidmatanMohonRefetch();
    });

    return {
      butirPerkhidmatan,
      batalPermohonan,
      formatDate,
      getDetails,
      isLoading,
      kenaikanPangkatMohonList,
      search,
      borangTypeLabel,
      borangJenisLabel,
      mohonStatusLabel,
      sambungDraf,
      getSuratSiaran,
      muatTurunSuratSiaran,
      mohon_id,
      selectedTab,
      getLampiran,
    };
  },
});
